import { SESSION_ILE_SICIL_SORGULA } from "../constants/requestUrls";
import { getRequest } from "../request";

const sessionIleSicilSorgula = () => {
  return getRequest({ url: SESSION_ILE_SICIL_SORGULA });
};

export default sessionIleSicilSorgula;